import { render, staticRenderFns } from "./AdminTableButton.vue?vue&type=template&id=10bc8cde&scoped=true&"
import script from "./AdminTableButton.vue?vue&type=script&lang=js&"
export * from "./AdminTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc8cde",
  null
  
)

export default component.exports